import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const getSingleVoucherAction = createAsyncThunk(
  "get-single-voucher",
  async (data = null, { rejectWithValue }) => {
    try {
      console.log("datt===================>",data)
      const res = await axios.get(
        `/admins/api/store/${data?.voucher_id}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleVoucherSlice = createSlice({
  name: "get-single-voucher",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSingleVoucherAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleVoucherAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getSingleVoucherAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const getSinglevoucherReducer = getSingleVoucherSlice.reducer;
